import { ReportSection } from "../reuseableComponents/monitoringReport/ReportSection";
import { convertTimeStampToDate } from "../../utilities/commonFunctions/timeConversionFunctions";

export const ComplianceScheduleTable = ({ complianceScheduleData }) => {
  const complianceSectionHeaders = ['Effective Date', 'Schedule Type', 'Required Activities', 'Associated Deficiencies', 'Activity Status', 'Due Date', 'Details'];
  const complianceSecondaryHeaders = ['Required Activities', 'Facility ID and Associated Deficiency', 'Activity Status', 'Due Date'];

  let gridData = {
    headers: complianceSectionHeaders,
    rows: complianceScheduleData.map((schedule, index) => {
      let deficiencyInfo = "";
      if (schedule.associatedDeficiencies && schedule.associatedDeficiencies.length > 0) {
        deficiencyInfo = schedule.associatedDeficiencies.map(def => `${def.facilityId} - ${convertTimeStampToDate(def.dateIdentified)} - ${def.facilityDeficiency}`).join('\r');
      }

      return {
        id: `${schedule.effectiveDate}-${index}`,
        cells: [
          schedule.effectiveDate ? convertTimeStampToDate(schedule.effectiveDate) : '',
          schedule.scheduleType,
          schedule.requiredActivities,
          deficiencyInfo,
          schedule.activityStatus,
          schedule.dueDate ? convertTimeStampToDate(schedule.dueDate) : '',
        ],
        secondaryGrid: schedule?.activities && schedule.activities.length > 1 ? {
          isCollapsible: true,
          headers: complianceSecondaryHeaders,
          rows: schedule.activities.map((activity, idx) => {
            let deficiencyInfo = "";
            if (activity.deficiencies && activity.deficiencies.length > 0) {
              deficiencyInfo = activity.deficiencies.map(def => `${def.facilityId} - ${convertTimeStampToDate(def.dateIdentified)} - ${def.facilityDeficiency}`).join('\r');
            }

            return {
              id: `${activity.dateIdentified}-${idx}`,
              cells: [
                activity.requiredActivities,
                deficiencyInfo,
                activity.activityStatus,
                convertTimeStampToDate(activity.dueDate)
              ]
            };
          })
        } : {}
      };
    })
  };

  return (
    <ReportSection 
      title="Compliance Schedules and Deficiencies" 
      gridData={gridData}
    />
  );
};
